export function fatal(message: string): never {
  const error = new Error(`[sycai] ${message}`);

  if (typeof globalThis.reportError === 'function') {
    globalThis.reportError(error);
  } else {
    setTimeout(() => {
      throw error;
    }, 0);
  }

  throw error;
}
